import { useEffect, useState } from 'react';
import { Select, MenuItem, Chip } from '@mui/material';
import { toast } from 'react-toastify';
import { UpdateStatus } from '../../../services/api/OrderAPI';

type StatusKey =
	| 'New'
	| 'Pending'
	| 'Processing'
	| 'Shipped'
	| 'Delivered'
	| 'Completed'
	| 'Cancelled';

const statusOptions: Record<StatusKey, string> = {
	New: 'New',
	Pending: 'Pending',
	Processing: 'Processing',
	Shipped: 'Shipped',
	Delivered: 'Delivered',
	Completed: 'Completed',
	Cancelled: 'Cancelled',
};

export const StatusCell = ({ params }: any) => {
	const [status, setStatus] = useState<StatusKey | string>(params.value);
	const slug = localStorage.getItem('slug');
	const location = window.location.pathname.split('/');

	useEffect(() => {
		setStatus(params.value);
	}, [params.value]);

	const getStatusColor = (status: StatusKey | string) => {
		switch (status) {
			case 'New':
				return 'default';
			case 'Pending':
				return 'warning';
			case 'Processing':
				return 'info';
			case 'Shipped':
				return 'primary';
			case 'Delivered':
			case 'Completed':
				return 'success';
			case 'Cancelled':
				return 'error';
			default:
				return 'default';
		}
	};

	const handleChange = async (event: any) => {
		const newStatus: StatusKey = event.target.value;
		setStatus(newStatus);

		try {
			const response = await UpdateStatus(params.row.orderId, { status: newStatus });
			if (response.success) {
				toast.success(response?.message);
			} else {
				toast.error(response?.data.message);
			}
		} catch (error) {
			console.error('Failed to update status:', error);
			setStatus(params.value);
		}
	};

	const isReadOnly = location.includes(slug as string);

	return (
		<>
			{isReadOnly ? (
				<Chip
					label={statusOptions[status as StatusKey] ?? status}
					color={getStatusColor(status)}
					size="small"
					variant="outlined"
				/>
			) : (
				<Select value={status} onChange={handleChange} size="small" sx={{ minWidth: 140 }}>
					{(Object.entries(statusOptions) as [StatusKey, string][]).map(
						([key, label]) => (
							<MenuItem key={key} value={key}>
								<Chip
									label={label}
									color={getStatusColor(key)}
									size="small"
									variant="outlined"
								/>
							</MenuItem>
						)
					)}
				</Select>
			)}
		</>
	);
};
